import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import type { RootState } from "./store";

const selectPosterReducers = createSelector(
  (state: RootState) => state,
  (state) => ({ ...state })
);
export const usePosterReducers = (): RootState => useSelector(selectPosterReducers);
